module.exports = __webpack_public_path__ + "static/media/14CarmelFountain.455b8789.jpg";